<template>

	<div class="flex-column fit-height">

		<v-card-title class="pb-1">Selezionare una Campagna</v-card-title>
		<v-subheader>Selezionando una campagna verrà mostrata la mappa dalla quale sarà possibile selezionare i dati da scaricare</v-subheader>
		<div class="flex-1">
			<v-list  dense>
				
				<v-list-item-group
					v-model="selectedCampagnaIdx"
					color="primary">

					<v-list-item
						v-for="(item, i) in listaCampagne"
						:key="i">
						<v-list-item-content>
							{{item.nome}}
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
	</div>
  
</template>

<style scoped>
</style>

<script>
import { EventBus } from '@/components/EventBus';
const { Utils } = require('@/assets/js/scripts/utils/Utils');
const { RequestsUtils } = require("@/assets/js/scripts/utils/RequestsUtils");

export default {
	name: 'DtmLeftPanel',
	props: [
		'prop_campagna_cod',
	],

	created() {
		this.requestCampagne();
	},

	data() {
		return {
			selectedCampagnaIdx: null,
			listaCampagne: [],
		}
	},

	methods: {
		/**
	 	* Lista campagne
	 	*/
		requestCampagne: function() {
			RequestsUtils.get(
				"../dtm/getCampagneDtm",
				// Params
				{},
				// Success Callback
				function (response) {
					let data = response.data.result;
					this.listaCampagne = data;

					if (data != null && data.length > 0) {
						if(!Utils.isNullOrUndefined(this.prop_campagna_cod) && !Utils.isEmpty(this.prop_campagna_cod)) {
							
							let indexCampagna = null;
							//let foundSet = this.data.filter(item => item.codice == this.prop_set_cartografico_cod);
							data.forEach((element, idx) => {
								if(element.codice == this.prop_campagna_cod) {
									indexCampagna = idx;
								}
							});
							if(indexCampagna != null) {
								this.selectedCampagnaIdx = indexCampagna;
								return;
							}
							
						}
						this.selectedCampagnaIdx = 0;
					}

					this.loading = false;
				}.bind(this),
				// Fail Callback
				null,
				// Show Message success
				false,
				// Show Loading
				true
			);
		}
	},

	watch: {
		selectedCampagnaIdx: {
			immediate : true, 
			handler: function(newVal, oldVal) {
				
				// lista set deve contenere valori
				if (newVal != null) {
					//  && !Utils.isNullOrUndefined(this.listaCampagne) && this.listaCampagne.length > 0) {
					let selected = this.listaCampagne[newVal];
					EventBus.$emit('campagna_selected', selected);
				}
			}
		}
	}
}
</script>